/**
 * Check if there's any overlap between two string arrays (case-insensitive)
 */
export function doArraysOverlap(arr1: string[], arr2: string[]): boolean {
    if (arr1.length === 0 || arr2.length === 0) {
        return false
    }
    const set1 = new Set(arr1.map((s) => s.toLowerCase()))
    return arr2.some((s) => set1.has(s.toLowerCase()))
}

export function chunkArray<T>(array: T[], batchSize: number): T[][] {
    const batches: T[][] = []
    for (let i = 0; i < array.length; i += batchSize) {
        batches.push(array.slice(i, i + batchSize))
    }
    return batches
}
